module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-MediumItalic.a945b745.ttf";